export default ({ options = {}, fields, rules = {} }) => {
  if (options.noValidate === true) {
    return {}
  }
  const extraRules = fields.reduce((previousValue, currentValue) => {
    return Object.assign({}, previousValue, currentValue.rule || {})
  }, {})
  return { ...rules, ...extraRules }
}



// WEBPACK FOOTER //
// ./packages/utils/parseRules.js